<template lang="html">
  <footer class="app-footer mt-auto border-t border-default bg-elevated">
    <div class="mx-auto w-full max-w-(--ui-container) px-4 pt-10 pb-8 sm:px-6 lg:pt-12 lg:pb-10">
      <div class="grid gap-10 sm:grid-cols-2 lg:grid-cols-[minmax(0,1.4fr)_repeat(2,minmax(0,1fr))] lg:gap-12">
        <!-- Brand + contact -->
        <div class="flex flex-col gap-5">
          <a
            href="/"
            class="inline-flex w-fit focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none"
            aria-label="На главную"
          >
            <UIcon
              :name="brandIcons.logoLargeDark"
              class="h-12 w-auto sm:h-14"
            />
          </a>

          <a
            :href="`tel:${phoneTel}`"
            class="group inline-flex w-fit items-center gap-2.5 text-lg font-semibold tracking-tight text-highlighted transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none motion-reduce:transition-none"
          >
            <span
              class="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary"
              aria-hidden="true"
            >
              <UIcon
                name="i-lucide-phone"
                class="size-4"
              />
            </span>
            {{ phoneDisplay }}
          </a>
        </div>

        <!-- Store nav -->
        <nav
          class="flex flex-col gap-3"
          aria-label="Разделы магазина"
        >
          <p class="text-xs font-semibold tracking-wider text-muted uppercase">
            Магазин
          </p>
          <ul class="flex flex-col gap-2">
            <li
              v-for="item in storeLinks"
              :key="item.to"
            >
              <NuxtLink
                :to="item.to"
                class="text-sm text-highlighted transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none motion-reduce:transition-none"
              >
                {{ item.label }}
              </NuxtLink>
            </li>
          </ul>
        </nav>

        <!-- Legal -->
        <nav
          class="flex flex-col gap-3"
          aria-label="Правовая информация"
        >
          <p class="text-xs font-semibold tracking-wider text-muted uppercase">
            Информация
          </p>
          <ul class="flex flex-col gap-2">
            <li
              v-for="item in legalLinks"
              :key="item.to"
            >
              <NuxtLink
                :to="item.to"
                class="text-sm text-highlighted transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none motion-reduce:transition-none"
              >
                {{ item.label }}
              </NuxtLink>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="border-t border-default bg-default/60">
      <div class="mx-auto flex w-full max-w-(--ui-container) flex-col gap-2 px-4 py-4 text-xs text-muted sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <p>
          © {{ currentYear }} Skuby
        </p>
        <a
          :href="`tel:${phoneTel}`"
          class="font-medium text-highlighted transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary focus-visible:outline-none motion-reduce:transition-none sm:hidden"
        >
          {{ phoneDisplay }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { brandIcons } from '~/app/theme/brand'

const phoneDisplay = '+7 (495) 123-45-67'
const phoneTel = '+74951234567'

const storeLinks = [
  { label: 'Главная', to: '/' },
  { label: 'Каталог', to: '/catalog' },
  { label: 'О бренде', to: '/about' },
  { label: 'Новости', to: '/news' },
  { label: 'Блог', to: '/blog' },
  { label: 'FAQ', to: '/faq' },
] as const

const legalLinks = [
  { label: 'Публичная оферта', to: '/offer' },
  { label: 'Политика конфиденциальности', to: '/privacy' },
  { label: 'Политика возвратов', to: '/returns' },
] as const

const currentYear = computed(() => new Date().getFullYear())
</script>
